<script>
import Chart from "chart.js";
import { Line, mixins } from "vue-chartjs";
import { EventBus } from "../main";
import moment from "moment";
import "chartjs-plugin-annotation";

const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["chartData", "chartAxis"],
  mounted() {
    Chart.defaults.global.defaultFontFamily = "Roboto";
    Chart.defaults.global.defaultFontColor = "#333";

    this.options.scales.yAxes[0].ticks.max = Number(this.chartAxis);

    if (this.chartData.datasets.length > 0) {
      this.updateChart();
    }

    if (!this.listenerMounted) {
      EventBus.$on("updateChartSnapshot", this.updateChart);
      EventBus.$on("updateChartAxis", this.updateAxis);
      this.listenerMounted = true;
    }
  },
  beforeDestroy: function() {
    EventBus.$off("updateChartSnapshot");
    EventBus.$off("updateChartAxis");
  },
  methods: {
    updateChart() {
      this.renderChart(this.chartData, this.options);
    },
    updateAxis(max) {
      this.options.scales.yAxes[0].ticks.max = max;
      this.renderChart(this.chartData, this.options);
    }
  },
  data: () => ({
    listenerMounted: false,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true
        }
      },
      tooltips: {
        mode: "nearest",
        callbacks: {
          title: function(tooltipItem) {
            return tooltipItem[0].value + " U";
          },
          label: function(tooltipItem) {
            return moment(tooltipItem.label).format("MMMM D, HH:mm");
          }
        },
        backgroundColor: "#f0f0f0",
        xPadding: 20,
        yPadding: 15,
        cornerRadius: 20,
        titleFontSize: 16,
        titleFontColor: "#000",
        bodyFontColor: "#777",
        bodyFontSize: 12,
        displayColors: false,
        caretPadding: 10
      },
      hover: {
        mode: "nearest",
        intersect: true
      },
      scales: {
        xAxes: [
          {
            display: true,
            type: "time",
            time: {
              unit: "hour"
            },
            distribution: "linear",
            stacked: true
          }
        ],
        yAxes: [
          {
            id: "bg",
            type: "linear",
            position: "left",
            scaleLabel: {
              display: true,
              labelString: "Blood Glucose (mmol/L)"
            },
            ticks: {
              max: 22,
              min: 0,
              stepSize: 2
            }
          }
        ]
      },
      annotation: {
        annotations: [
          {
            type: "box",
            yScaleID: "bg",
            yMax: 10,
            yMin: 3.9,
            borderWidth: 1,
            borderColor: "rgba(0,0,0,0)",
            backgroundColor: "rgba(48, 76, 156, 0.15)"
          }
        ],
        drawTime: "afterDraw"
      }
    }
  })
};
</script>
